/**
 * HAT-1109: ה-WebApi מחזיר שני סוגי הודעות שגיאה בגוף התשובה.
 *
 * 1. הודעות שנוסחו עבור המשתמש - תמיד בעברית ("לא ניתן להגיש בקשת תמיכה עבור רכז
 *    של הקרן.", "מספר חשבונית X כבר שימש בבקשת תמיכה קודמת עבור ספק זה.").
 * 2. שומרי סף פנימיים באנגלית - ולידציות 400 ("MultiRequestTotalCount must be
 *    greater than 0, got 0."), 403 שאף מדליף את כתובת המייל של המשתמש, 404,
 *    וטקסט exception גולמי ב-500 ("Error creating support request for fund 4344: ...").
 *
 * הטפסים הציגו את שני הסוגים כמו שהם, ולכן רכזת קרן דוברת עברית קיבלה מדי פעם
 * הודעה באנגלית. הפונקציה מחזירה את הודעת השרת רק כשהיא מהסוג הראשון; על השני
 * המסך הקורא נופל להודעה העברית הגנרית שלו, והפרטים נשארים בלוגים של השרת.
 */

const HEBREW_LETTER = /[֐-׿]/;

/**
 * מחלץ מגוף התשובה של axios הודעה שראויה להצגה למשתמש, או null אם אין כזו.
 * גוף התשובה הוא מחרוזת (ההתנהגות הרגילה של WebApi) או אובייקט עם שדה message.
 */
export function extractUserFacingServerMessage(responseData: unknown): string | null {
  const raw =
    typeof responseData === 'string'
      ? responseData
      : typeof responseData === 'object'
        && responseData !== null
        && 'message' in responseData
        && typeof (responseData as { message?: unknown }).message === 'string'
        ? (responseData as { message: string }).message
        : null;

  const trimmed = raw?.trim();
  if (!trimmed) return null;

  return HEBREW_LETTER.test(trimmed) ? trimmed : null;
}
